import { render, staticRenderFns } from "./SplashPlaylists.vue?vue&type=template&id=24bc4604&scoped=true&"
import script from "./SplashPlaylists.vue?vue&type=script&lang=js&"
export * from "./SplashPlaylists.vue?vue&type=script&lang=js&"
import style0 from "./SplashPlaylists.vue?vue&type=style&index=0&id=24bc4604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc4604",
  null
  
)

export default component.exports